import { useEffect, useState } from "react";

// Paste your deployed Google Apps Script URL here
const API_URL =
  "https://script.google.com/macros/s/AKfycbzPAwEsRVlC_r2bCnaEyBNisSO8EkegRdV7Eyq6cbLroePKKjPn0OM0vWENvdlolGVClQ/exec";

export default function ManagementDashboard() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  // Read data from Google Sheet
  const fetchStudents = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_URL);
      const data = await response.json();
      setStudents(data);
    } catch (error) {
      console.error("Error reading spreadsheet data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  // Update payment status (e.g., clicking checkmark to mark PAID or change type)
  const handleUpdatePayment = async (rowNumber, phone, newPaymentType) => {
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        mode: "no-cors", // Required to bypass simple browser CORS for web apps
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "update",
          rowNumber: rowNumber,
          Phone: phone, // Backup identifier
          Payment: newPaymentType, // 'paid', 'scholarship', or 'due'
        }),
      });

      // Since mode is 'no-cors', we won't read the response directly,
      // instead, update local state or re-fetch to reflect changes.
      alert(`Payment updating to ${newPaymentType}...`);
      setTimeout(() => fetchStudents(), 1500);
    } catch (error) {
      console.error("Error sending update:", error);
    }
  };

  if (loading) return <div>Loading records from Google Sheets...</div>;

  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      <h2>Management Dashboard</h2>

      {/* Dynamic Data List rendering matching your UI design structure */}
      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        {students.map((student, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ddd",
              padding: "15px",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Person Details block */}
            <div>
              <span
                style={{
                  background: "#e0e0e0",
                  padding: "2px 6px",
                  borderRadius: "3px",
                  fontSize: "12px",
                }}
              >
                Level {student.Level}
              </span>
              <span
                style={{
                  marginLeft: "10px",
                  background:
                    student.Payment === "scholarship" ? "#cdf" : "#dfd",
                  padding: "2px 6px",
                  borderRadius: "3px",
                  fontSize: "12px",
                }}
              >
                {student.Payment?.toUpperCase()}
              </span>
              <h3 style={{ margin: "5px 0" }}>{student.Name}</h3>
              <p style={{ margin: "2px 0", fontSize: "14px", color: "#666" }}>
                {student.FathersName}
              </p>
              <p style={{ margin: "2px 0", fontSize: "14px", color: "#666" }}>
                📞 {student.Phone}
              </p>
              <p style={{ margin: "2px 0", fontSize: "12px", color: "#99px" }}>
                {student.Occupation}, {student.Address}
              </p>
            </div>

            {/* Middle Action Block: Update Spreadsheet Values */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <button
                onClick={() =>
                  handleUpdatePayment(student.rowNumber, student.Phone, "paid")
                }
                style={{
                  backgroundColor: "#d4edda",
                  color: "#155724",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "4px",
                }}
              >
                Accept Paid (✔)
              </button>
              <button
                onClick={() =>
                  handleUpdatePayment(
                    student.rowNumber,
                    student.Phone,
                    "scholarship",
                  )
                }
                style={{
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "4px",
                }}
              >
                Assign Scholarship
              </button>
            </div>

            {/* Quick Note / Message Display block */}
            <div
              style={{
                maxWidth: "250px",
                fontSize: "13px",
                fontStyle: "italic",
                color: "#555",
              }}
            >
              <strong>Msg:</strong> {student.Message || "No text message"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
